export const FEMENINO = 'Femenino'
export const MASCULINO = 'Masculino'
export const MIXTO = 'Mixto'
export const TODOS = 'Todos'
export const FOUR = '4vs4'
